import styled from 'styled-components';
import ChartPageBase from '../ChartSections/ChartPageBase';

export default styled(ChartPageBase)``;
